var map = {
	"./choose_pic.mp3": "cffe",
	"./five.mp3": "07ad",
	"./four.mp3": "e225",
	"./six.mp3": "6a31",
	"./two_blue.mp3": "5715",
	"./two_green.mp3": "852f",
	"./two_orange.mp3": "271e",
	"./two_white.mp3": "e26f",
	"./two_yellow.mp3": "9130"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6e78";